import React, { useContext } from 'react';
import { Row } from 'reactstrap';
import { QuestionsGroup } from '../QuestionsGroup';
import FaqContext from '../../../../contexts/FAQContext';

export const QuestionsList = () => {
  const {
    faqOriginal: { categories },
  } = useContext(FaqContext);

  return categories ? (
    <Row className="mt-4">
      {Object.keys(categories).sort((a, b) => {
        if (a < b) return -1;
        if (a > b) return 1;
        return 0;
      }).map(group => {
        return <QuestionsGroup key={group} data={categories[group]} />
      })}
    </Row>
  ) : null;
};
